// extracted by mini-css-extract-plugin
export default {"root":"AssessmentDetailsPage_root__Nji69","restricted":"AssessmentDetailsPage_restricted__BOGnk"};